import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import MarketplaceItem from '../../components/MarketplaceItem/MarketplaceItem';
import marketplaceStore from '../../store/marketplaceStore';
import { LoadingStatus } from '~/types/main';
import { EmptyList } from '~/view/components/EmptyList/EmptyList';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

const ListLoader = () => {
  return (
    <>
      {[...Array(6).fill(null)].map((_, idx) => (
        <Skeleton key={idx} height={100} style={{ borderRadius: 26 }} />
      ))}
    </>
  );
};

const MarketplaceFeaturesList: FC = observer((): JSX.Element => {
  const { filteredFeaturesList } = marketplaceStore;
  const isLoading = marketplaceStore.loadingStatus === LoadingStatus.Loading;

  useEffect(() => {
    marketplaceStore.fetchMarketplaceFeaturesList();
  }, []);

  if (!isLoading && !filteredFeaturesList.length) {
    return <EmptyList text="no_results_found" showEmptyListImage />;
  }

  return (
    <ScrollableBlock className="d-flex flex-column flex-grow-1 mt-3" scrollClassName="marketplace-features-list" showScrollbar scrollbarSize="normal">
      {isLoading ? (
        <ListLoader />
      ) : (
        filteredFeaturesList.map((feature) => (
          <MarketplaceItem key={feature.key} featureKey={feature.key} status={feature.status} purchased={feature.isPurchased} />
        ))
      )}
    </ScrollableBlock>
  );
});

export default MarketplaceFeaturesList;
